// TODO: firefly-1-9758-ui clean up duplicate constants after FF expires
export const environment = {
  production: true,
  type: 'prod',
  enableMonitoring: true,
  appInsights: {
    connectionString:
      'InstrumentationKey=dc5e6a01-a087-4d19-85dd-69df16361e8f;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=3d18c0df-9299-4933-b201-de8f66fd5c1b',
  },
  siteManagementApiBaseUrl: 'https://apim-prod-spotlight.azure-api.net/sites',
  taskManagementApiBaseUrl: 'https://apim-prod-spotlight.azure-api.net/tasks',
  trailersApiBaseUrl: 'https://apim-prod-spotlight.azure-api.net/trailers',
  yardOpsApiBaseUrl: 'https://apim-prod-spotlight.azure-api.net/yard-ops',

  taskMessagesWSBaseUrl: 'wss://apim-prod-spotlight.azure-api.net/api/task-messages-notifications',
  siteTasksWSBaseUrl: 'wss://apim-prod-spotlight.azure-api.net/api/site-tasks-notifications',
  doorsWSBaseUrl: 'wss://apim-prod-spotlight.azure-api.net/api/site-doors-notifications',
  trailersWSBaseUrl: 'wss://apim-prod-spotlight.azure-api.net/api/trailer-notifications',

  trailersWsBaseUrlYO: 'wss://apim-prod-spotlight.azure-api.net/api/yardops-trailer-notifications',
  taskMessagesWSBaseUrlYO: 'wss://apim-prod-spotlight.azure-api.net/api/yardops-task-messages-notifications',
  siteTasksWSBaseUrlYO: 'wss://apim-prod-spotlight.azure-api.net/api/yardops-site-tasks-notifications',
  doorsWSBaseUrlYO: 'wss://apim-prod-spotlight.azure-api.net/api/yardops-site-doors-notifications',

  authApiBaseUrl: 'https://apim-prod-spotlight.azure-api.net/auth',
  auth0Domain: 'auth.nexusyms.com',
  auth0ClientId: 'fyT9xhsVBWywhnCXhMu1kIr3tlq7OVLV',
  auth0RedirectUrl: 'https://www.nexusyms.com',
  auth0Audience: 'https://authentication-api',
  auth0Connection: 'LazerTech-Users',
  azureBlobStorage: 'https://saprodwebui.blob.core.windows.net',
  launchDarklyClientId: '67c9b2681a955809d7fa3aaa',
  azureBlobSasString:
    'sp=racwdli&st=2025-02-12T13:45:10Z&se=2026-04-01T20:45:10Z&spr=https&sv=2022-11-02&sr=c&sig=AcPSvrSEDfv8eXehHWe8vgYygzglt5AUL8hMQMBi6OU%3D',
};
